/* eslint-disable jsx-a11y/img-redundant-alt */
import { FC } from 'react';
import DeviceManager from '@/components/util/deviceManager';
import { Props } from './types';
import { getVideoLink } from '@/components/util';
import ReactModal from 'react-modal';

type ModalProps = {
  children: any;
  isOpen: boolean;
  id?: string;
  ariaHideApp: boolean;
  style?: ReactModal.Styles;
  onRequestClose?: () => void;
  overlayClassName?: string;
  contentLabel?: string;
  className?: string;
};

const Modal: FC<ModalProps> = ({ children, ...props }) => (
  <ReactModal {...props}>{children}</ReactModal>
);

export const TimeIsUpModal = ({
  showTimeIsUpModal,
  getCurrentLanguage,
  timeUpImg,
  timeUpImgMob,
  timeUpVideo,
  timeUpImgMobH,
  timeUpImgH,
  timeUpImgW,
  timeUpImgMobW,
  timeUpRes,
  timeUpMobVideo,
  tourId,
  gameId,
  isWhiteLabel,
}: Props) => {
  const isMobile = DeviceManager.isMobile();
  let videoLink;
  if (!isMobile && timeUpVideo) videoLink = timeUpVideo;
  else if (isMobile && timeUpMobVideo) videoLink = timeUpMobVideo;

  const imagePath = `${process.env.NEXT_PUBLIC_CDN}/tours/${tourId}/game/${gameId}/`;
  const postfix = isWhiteLabel ? '' : 'treedis';
  const timeUpDefaultImg = `/images/timeisup${postfix}.png`;
  const timeUpMobileDefaultImg = `/images/timeisupmobile${postfix}.png`;
  let imageLink;
  if (!isMobile && timeUpImg) imageLink = imagePath + timeUpImg;
  else if (isMobile && timeUpImgMob) imageLink = imagePath + timeUpImgMob;

  const sizeW = timeUpRes === 'percentage' ? 'vw' : 'px';
  const sizeH = timeUpRes === 'percentage' ? 'vh' : 'px';

  const width = (isMobile ? timeUpImgMobW : timeUpImgW) + sizeW;
  const heightModificator = videoLink && imageLink ? 2 : 1; // if we have video or img height is 100%, if video+link = 200%
  // eslint-disable-next-line radix
  const height = heightModificator * parseInt(isMobile ? timeUpImgMobH : timeUpImgH) + sizeH;

  return (
    <Modal
      className="game-time-is-up-modal"
      ariaHideApp={false}
      isOpen={showTimeIsUpModal}
      onRequestClose={() => {
        // eslint-disable-next-line no-restricted-globals
        location.reload();
      }}
    >
      <i
        className="fas fa-times"
        onClick={() => {
          // eslint-disable-next-line no-restricted-globals
          location.reload();
        }}
      />

      {!imageLink && !videoLink ? (
        <div
          className="game-tutorial-modal-wrap"
          style={{ width: isMobile ? '370px' : '800px', height: '550px' }}
        >
          <img
            alt="time is up default image"
            src={isMobile ? timeUpMobileDefaultImg : timeUpDefaultImg}
            onClick={() => {
              // eslint-disable-next-line no-restricted-globals
              location.reload();
            }}
          />
        </div>
      ) : (
        <div className="game-tutorial-modal-wrap" style={{ height, width }}>
          {imageLink && <img alt="time is up image" src={imageLink} />}
          {videoLink && (
            <iframe
              src={getVideoLink(videoLink, {
                autoplay: 0,
                subtitles: getCurrentLanguage()?.languageCode,
              })}
              frameBorder={0}
              allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
            />
          )}
        </div>
      )}
    </Modal>
  );
};
